window.config = {
	isOnAzureCloud: true,
	authMethod: "OAUTH",
	servicenameSubstitution: {},
	configURL: {
	},
};
